@if (uploading()){
    <div class="d-flex align-items-center">
        <div class="spinner-border text-info mr-5" aria-hidden="true"></div>
        <strong role="status">Import en cours...</strong>
    </div>
} @else if (uploadStatusOk() === undefined) {
    <label class="drag-zone" [class]="file() != undefined ? 'has-file' : ''" [appDragDrop]="dragDropEnabled"
        (dropped)="handleFileDrop($event)">
        <input type="file" [accept]="'text/csv'" [multiple]="false" (change)="addFile(fileInput.files![0])" #fileInput
            class="visually-hidden" />
        <div class="content-upload">
            @if (!file()) {
                <i class="bi bi-upload"></i>
                <span>Importer un CSV</span>
                <span>(Click ou Drag & Drop)</span>
            }
            @else {
                <i class="bi bi-file-earmark-text"></i>
                <span>{{ file()?.name }}</span>
            }
        </div>
    </label>

    <div class="buttons-holder">
        <button type="button" [disabled]="!file()" class="btn btn-outline-danger me-2" (click)="removeFile()">
            Supprimer le fichier
        </button>
        <button type="button" [disabled]="!file()" class="btn btn-primary me-2" (click)="uploadFile()">
            Importer le fichier
        </button>
    </div>
} @else if (uploadStatusOk() === true) {
    <div class="alert alert-success uploadResponseContent" role="alert">
        Fichier importé avec succès !
    </div>
    <button type="button" class="btn btn-outline-primary me-2" (click)="resetPage()">
        Recommencer avec un autre fichier
    </button>
} @else {
    <div class="alert alert-danger uploadResponseContent" role="alert">
        Une erreur est survenue lors de l'importation du fichier.
    </div>
    <button type="button" class="btn btn-outline-primary me-2" (click)="resetPage()">
        Recommencer avec un autre fichier
    </button>
}